import { Contact } from '@pelicargo/types';

export const prettyContact = (contact: Contact) => {
  if (!contact) return;

  return [contact?.full_name || contact?.preferred_name, contact?.phone_number, contact?.email]
    .filter(Boolean)
    .join('\n');
};
